// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"Paragraph_paragraph__18i8G"};